import React, { useEffect, useState, useCallback } from 'react';

/** 같은 탭 SPA 이동 시 접기 상태 유지 (탭·브라우저 닫으면 sessionStorage 초기화) */
const QUICK_MENU_ACTIVE_KEY = 'quick-menu-area-active';

function readStoredActive(): boolean {
  try {
    const v = sessionStorage.getItem(QUICK_MENU_ACTIVE_KEY);
    if (v === 'false') return false;
    if (v === 'true') return true;
  } catch {
    // ignore
  }
  return true;
}

function persistStoredActive(active: boolean): void {
  try {
    sessionStorage.setItem(QUICK_MENU_ACTIVE_KEY, active ? 'true' : 'false');
  } catch {
    // ignore
  }
}

const QuickMenu: React.FC = () => {
  const [isActive, setIsActive] = useState(readStoredActive);

  useEffect(() => {
    persistStoredActive(isActive);
  }, [isActive]);

  const closeAllDepth2 = useCallback((): void => {
    const quickPanels = document.querySelectorAll<HTMLButtonElement>('.quick-panel');
    quickPanels.forEach((panel) => {
      const li = panel.closest('li');
      const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

      if (!li || !depth2) return;

      li.classList.remove('active');
      depth2.style.height = '0';
      panel.setAttribute('title', '메뉴 열기');
    });
  }, []);

  useEffect(() => {
    if (!isActive) {
      closeAllDepth2();
    }
  }, [isActive, closeAllDepth2]);

  useEffect(() => {
    const quickPanels = document.querySelectorAll<HTMLButtonElement>('.quick-panel');

    const cleanups: Array<() => void> = [];

    quickPanels.forEach((panel) => {
      const handleDepthToggle = (): void => {
        const li = panel.closest('li');
        const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

        if (!li || !depth2) return;

        const depthActive = li.classList.contains('active');

        if (depthActive) {
          depth2.style.height = '0';
          li.classList.remove('active');
          panel.setAttribute('title', '메뉴 열기');
        } else {
          depth2.style.height = `${depth2.scrollHeight}px`;

          depth2.addEventListener(
            'transitionend',
            () => {
              depth2.style.height = 'auto';
            },
            { once: true }
          );

          li.classList.add('active');
          panel.setAttribute('title', '메뉴 닫기');
        }
      };

      panel.addEventListener('click', handleDepthToggle);
      cleanups.push(() => panel.removeEventListener('click', handleDepthToggle));
    });

    return () => {
      cleanups.forEach((fn) => fn());
    };
  }, []);

  const handleQuickToggle = (): void => {
    setIsActive((prev) => !prev);
  };

  return (
    <>
      <div className="quick-bg"></div>
      <aside className={`quick-area${isActive ? ' active' : ''}`}>
        <div className="quick-w">
          <button
            type="button"
            title={isActive ? '퀵메뉴 닫기' : '퀵메뉴 열기'}
            aria-label={isActive ? '퀵메뉴 닫기' : '퀵메뉴 열기'}
            className="quick-open"
            onClick={handleQuickToggle}
          >
            <i className="icon icon-quick" aria-hidden="true" />
          </button>
          {/* 20260129 수정 */}
          <ul className="quick">
            <li>
              <a href='https://www.aica-gj.kr/main.php' className="quick-btn" target="_blank" title="새 창 열림">
                AICA 홈페이지
              </a>
            </li>
            <li>
              <button type="button" title="메뉴 열기" className="quick-btn quick-panel">
                AI 통합지원 서비스 플랫폼
              </button>
                <ul className="quick-depth2-w">
                  <li><a href='https://aidc.atops.or.kr/' className="quick-depth2" target="_blank" title="새 창 열림">컴퓨팅자원 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/tsp`} className="quick-depth2" target="_blank" title="새 창 열림">실증장비 이용신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/lms`} className="quick-depth2" target="_blank" title="새 창 열림">AI 융합아카데미</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/`} className="quick-depth2" target="_blank" title="새 창 열림">코디네이팅·자문 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/dxp`} className="quick-depth2" target="_blank" title="새 창 열림">데이터안심구역 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/`} className="quick-depth2" target="_blank" title="새 창 열림">회의실 등 예약</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/npu`} className="quick-depth2" target="_blank" title="새 창 열림"> AI 반도체</a></li>
                  {/* <li><a href={`${process.env.REACT_APP_DOMAIN}/biz`} className="quick-depth2" target="_blank" title="새 창 열림">사업관리시스템</a></li> */}
                </ul>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default QuickMenu;
